import axios from 'axios';
import React, { useContext, useRef, useTransition, useEffect } from "react";
import { Context } from "./Reducers/Store";
import { useTokenHelper } from './Hooks/useTokenHelper';

/* Axios Interceptors */
export const WithAxios = ({ children }) => {
    const [state, dispatch] = useContext(Context);
    const requests = useRef(0);
    const tokenHelper = useTokenHelper();
    
    const contaIdRef = useRef(state.contaId);

    const { t } = useTransition();

    useEffect(() => {
        contaIdRef.current = state.contaId;
    }, [state.contaId]);

    if (global._interceptor1 != null) axios.interceptors.request.eject(global._interceptor1);
    if (global._interceptor2 != null) axios.interceptors.response.eject(global._interceptor2);

    global._interceptor1 = axios.interceptors.request.use(
        async request => {
            if (!request.url.includes("/auth/refresh")) {
                const jwtToken = await tokenHelper.getToken();
                if (jwtToken != null)
                    request.headers.Authorization = 'Bearer ' + jwtToken;
            }

            if (contaIdRef?.current) {
                request.headers['x-conta-id'] = contaIdRef.current;
            }

            if (!request.metadata?.ignoreLoading) {
                dispatch({ type: 'SET_LOADING', payload: true });
                requests.current += 1;
            }

            return request;
        }, error => {
            return Promise.reject(error);
        }
    );

    global._interceptor2 = axios.interceptors.response.use(
        response => {
            if (!response.config?.metadata?.ignoreLoading) {
                requests.current -= 1;
                if (requests.current <= 0) {
                    requests.current = 0;
                    dispatch({ type: 'SET_LOADING', payload: false });
                }
            }
            return response;
        },
        error => {
            requests.current -= 1;
            if (requests.current <= 0) {
                requests.current = 0;
                dispatch({ type: 'SET_LOADING', payload: false });
            }

            if (error.status == "401") {
                if (!error.response || !error.response.data || !["USER_OR_PASSWORD_INVALID", "USER_OR_CODE_INVALID"].includes(error.response.data.message)) {
                    dispatch([{ type: 'SET_LOGGED', payload: null }, { type: "SET_USER_PREFERENCES", payload: null }]);
                    error.message = 'SESSION_EXPIRED';
                }
            } else if (error.status == "408" || error.status == "504") {
                console.error("TIMEOUT", error);
            }

            return Promise.reject(error);
        }
    );

    return children;
};